import script from "./auth-email-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth-email-form.vue?vue&type=script&lang=ts&setup=true"

import "./auth-email-form.vue?vue&type=style&index=0&id=65a2d22a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65a2d22a"]])

export default __exports__